import React from 'react';
import { IGetPaystubPayInfoRes } from '~/types/paystub';

interface IPaystubPaymentInfoProps {
  deduction: IGetPaystubPayInfoRes['deduction'];
}

function PaystubPaymentInfo({ deduction }: IPaystubPaymentInfoProps) {
  return (
    <div className="mt-12 flex flex-col gap-[10px]">
      {/* 제목 */}
      <div className="flex items-center justify-between">
        <p className="text-[18px] font-bold leading-[30px] text-[#333]">지급내역 확인</p>
      </div>

      {/* 테이블 */}
      <div className="overflow-hidden rounded-lg border border-[#d9d9d9]">
        {/* 헤더 */}
        <div className="flex w-full items-center border-b border-[#d9d9d9] bg-[#f4f4f4]">
          <div className="flex h-[32px] w-[135px] items-center justify-center border-r border-[#d9d9d9] px-[11.52px] py-[5.76px]">
            <p className="text-[14px] font-semibold leading-[1.5] text-[#111]">항목</p>
          </div>
          <div className="flex w-[337px] items-center justify-center border-r border-[#d9d9d9] px-[11.52px] py-[5.76px]">
            <p className="text-[14px] font-semibold leading-[1.5] text-[#111]">산출식</p>
          </div>
          <div className="flex flex-1 items-center justify-center px-[11.52px] py-[5.76px]">
            <p className="text-[14px] font-semibold leading-[1.5] text-[#111]">값</p>
          </div>
        </div>

        {/* 동적 항목들 */}
        {deduction.basic_items.map((item, index) => (
          <div key={index} className="flex w-full items-center border-b border-[#d9d9d9] bg-white">
            <div className="flex w-[135px] items-center border-r border-[#d9d9d9] px-[11.52px] py-[7.68px]">
              <p className="text-[14px] leading-[17.28px] text-[#111]">{item.name}</p>
            </div>
            <div className="flex w-[337px] items-center justify-center border-r border-[#d9d9d9] px-[11.52px] py-[7.68px]">
              <div className="text-center text-[12px] leading-[17.28px] text-[#767676]">
                {item.formula ? (
                  item.formula.split('\n').map((line, idx) => (
                    <p key={idx} className={idx > 0 ? '' : 'mb-0'}>
                      {line}
                    </p>
                  ))
                ) : (
                  <p>-</p>
                )}
              </div>
            </div>
            <div className="flex flex-1 items-center justify-end px-[11.52px] py-[7.68px]">
              <p className="text-[14px] leading-[17.28px] text-[#111]">{item.value ? item.value : '-'}</p>
            </div>
          </div>
        ))}
        
        {deduction.payment_items.map((item, index) => (
          <div key={index} className="flex w-full items-center border-b border-[#d9d9d9] bg-white">
            <div className="flex w-[135px] items-center border-r border-[#d9d9d9] px-[11.52px] py-[7.68px]">
              <p className="text-[14px] leading-[17.28px] text-[#111]">{item.name}</p>
            </div>
            <div className="flex w-[337px] items-center justify-center border-r border-[#d9d9d9] px-[11.52px] py-[7.68px]">
              <div className="text-center text-[12px] leading-[17.28px] text-[#767676]">
                {item.formula ? (
                  item.formula.split('\n').map((line, idx) => (
                    <p key={idx} className={idx > 0 ? '' : 'mb-0'}>
                      {line}
                    </p>
                  ))
                ) : (
                  <p>-</p>
                )}
              </div>
            </div>
            <div className="flex flex-1 items-center justify-end px-[11.52px] py-[7.68px]">
              <p className="text-[14px] leading-[17.28px] text-[#111]">{item.value ? item.value : '-'}</p>
            </div>
          </div>
        ))}

        {/* 지급액 합계 */}
        <div className="flex w-full items-center bg-white">
          <div className="flex w-[472px] items-center justify-center border-r border-[#d9d9d9] px-[11.52px] py-[7.68px]">
            <p className="text-[14px] font-semibold leading-[17.28px] text-[#111]">지급액 합계</p>
          </div>
          <div className="flex flex-1 items-center justify-end px-[11.52px] py-[7.68px]">
            <p className="text-[14px] font-semibold leading-[17.28px] text-[#111]">{deduction.total_pay}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaystubPaymentInfo;
